export default __webpack_public_path__ + "static/media/09.8a7af272.jpg";